// FILE: src/Redux/Reducers/ZoneReducer.js
import * as Types from '../Constants/AllConstants';

// Create zone configuration
export const CreateZoneConfigReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_CONFIG_CREATE_REQUEST:
      return { loading: true };
    case Types.ZONE_CONFIG_CREATE_SUCCESS:
      return { loading: false, success: true, zoneConfig: action.payload };
    case Types.ZONE_CONFIG_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_CONFIG_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Get league zone configurations
export const GetLeagueZoneConfigsReducer = (state = { zoneConfigs: [] }, action) => {
  switch (action.type) {
    case Types.ZONE_CONFIG_LIST_REQUEST:
      return { loading: true };
    case Types.ZONE_CONFIG_LIST_SUCCESS:
      return { loading: false, zoneConfigs: action.payload };
    case Types.ZONE_CONFIG_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_CONFIG_LIST_RESET:
      return { zoneConfigs: [] };
    default:
      return state;
  }
};

// Update zone configuration
export const UpdateZoneConfigReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_CONFIG_UPDATE_REQUEST:
      return { loading: true };
    case Types.ZONE_CONFIG_UPDATE_SUCCESS:
      return { loading: false, success: true, zoneConfig: action.payload };
    case Types.ZONE_CONFIG_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_CONFIG_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete zone configuration
export const DeleteZoneConfigReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_CONFIG_DELETE_REQUEST:
      return { loading: true };
    case Types.ZONE_CONFIG_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.ZONE_CONFIG_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_CONFIG_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Initialize African league zones
export const InitializeAfricanZonesReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_INITIALIZE_AFRICAN_REQUEST:
      return { loading: true };
    case Types.ZONE_INITIALIZE_AFRICAN_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case Types.ZONE_INITIALIZE_AFRICAN_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_INITIALIZE_AFRICAN_RESET:
      return {};
    default:
      return state;
  }
};

// Initialize custom zones
export const InitializeCustomZonesReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_INITIALIZE_CUSTOM_REQUEST:
      return { loading: true };
    case Types.ZONE_INITIALIZE_CUSTOM_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case Types.ZONE_INITIALIZE_CUSTOM_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_INITIALIZE_CUSTOM_RESET:
      return {};
    default:
      return state;
  }
};

// Apply zones to standings
export const ApplyZonesToStandingsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_APPLY_TO_STANDINGS_REQUEST:
      return { loading: true };
    case Types.ZONE_APPLY_TO_STANDINGS_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case Types.ZONE_APPLY_TO_STANDINGS_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_APPLY_TO_STANDINGS_RESET:
      return {};
    default:
      return state;
  }
};

// Quick setup zones
export const QuickSetupZonesReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ZONE_QUICK_SETUP_REQUEST:
      return { loading: true };
    case Types.ZONE_QUICK_SETUP_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case Types.ZONE_QUICK_SETUP_FAIL:
      return { loading: false, error: action.payload };
    case Types.ZONE_QUICK_SETUP_RESET:
      return {};
    default:
      return state;
  }
};

// Get zone for position
export const GetZoneForPositionReducer = (state = { zone: null }, action) => {
  switch (action.type) {
    case Types.ZONE_FOR_POSITION_REQUEST:
      return { loading: true };
    case Types.ZONE_FOR_POSITION_SUCCESS:
      return { loading: false, zone: action.payload };
    case Types.ZONE_FOR_POSITION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};